mainApp.service('LinksProcessingService', function () {
    return {
        addLink: function (monitorItem, dataItem, type, typesTitles) {
            if (!dataItem.mergedLink && ((dataItem.device && dataItem.device.deviceCategory === 'DEVICE_CATEGORY_SOCKET' && (dataItem.interfaceName === '' || dataItem.deviceId === '0')))) {
                console.log("Removed a socket link that doesn't have an interface name");
                return;
            }
            var linkName = dataItem.mergedLink ? 'mergedLink' : (type ? dataItem.interfaceName : dataItem.interfaceType) + (dataItem.type && dataItem.type === 'login' ? dataItem.deviceId : '');
            var averageThroughputUp = dataItem.mergedLink ? 0 : dataItem.averageThroughputUp;
            var averageThroughputDown = dataItem.mergedLink ? 0 : dataItem.averageThroughputDown;

            monitorItem.links[linkName] = {
                rtStatsList: dataItem.rtStatsList,
                distanceAverage: dataItem.distanceAverage,
                distanceTotal: dataItem.distanceTotal,
                distanceMax: dataItem.distanceMax,
                throughput: dataItem.throughput,
                popId: dataItem.popId,
                maxBandwidthReceived: dataItem.maxBandwidthReceived,
                maxBandwidthSent: dataItem.maxBandwidthSent,
                packetLossUp: dataItem.packetLossUp,
                packetLossDown: dataItem.packetLossDown,
                averageThroughputUp: averageThroughputUp,
                averageThroughputDown: averageThroughputDown,
                averagePacketLossUp: dataItem.averagePacketLossUp * 100,
                averagePacketLossDown: dataItem.averagePacketLossDown * 100,
                fecRecoveryRateUp: dataItem.fecRecoveryRateUp * 100,
                fecRecoveryRateDown: dataItem.fecRecoveryRateDown * 100,
                serverPacketsSent: dataItem.serverPacketsSent,
                serverPacketsReceived: dataItem.serverPacketsReceived,
                clientPacketsSent: dataItem.clientPacketsSent,
                clientPacketsReceived: dataItem.clientPacketsReceived,
                averagePacketLossUpRaw: dataItem.averagePacketLossUpRaw * 100,
                averagePacketLossDownRaw: dataItem.averagePacketLossDownRaw * 100,
                averagePacketDiscardedUpRaw: dataItem.averagePacketDiscardedUpRaw * 100,
                averagePacketDiscardedDownRaw: dataItem.averagePacketDiscardedDownRaw * 100,
                pops: dataItem.pops,
                packetsReceivedDropped: dataItem.packetsReceivedDropped,
                packetsSentDropped: dataItem.packetsSentDropped,
                uptime: dataItem.uptime,
                location: dataItem.location,
                lastLogin: dataItem.lastLogin,
                device: dataItem.device,
                externalIP: dataItem.externalIP,
                internalIP: dataItem.internalIP,
                distance: dataItem.distance,
                connectionState: dataItem.connectionState,
                protocol: dataItem.protocol,
                deviceId: dataItem.deviceId,
                interfaceName: dataItem.interfaceName,
                title: type ? dataItem.interfaceName : (typesTitles && typesTitles[dataItem.interfaceType] ? typesTitles[dataItem.interfaceType] : dataItem.interfaceType),
                status: dataItem.status,
                hostsCount: dataItem.hostsCount,
                linkId: linkName,
                physicalPort: dataItem.physicalPort,
                averageJitterUp: dataItem.averageJitterUp,
                averageJitterDown: dataItem.averageJitterDown,
                averageJitterOfoUp: dataItem.averageJitterOfoUp,
                averageJitterOfoDown: dataItem.averageJitterOfoDown,
            };

            if (dataItem.site && dataItem.site.interfaceData) {
                var interDatas = dataItem.site.interfaceData.filter(function (item) { return item.interface_id === dataItem.interfaceName && item.interfaceType === dataItem.interfaceType; });
                // monitorItem.links[linkName].linkName = (interDatas && interDatas[0]) ? interDatas[0].name : null;
                monitorItem.links[linkName].title = (interDatas && interDatas[0]) ? interDatas[0].name : monitorItem.links[linkName].title;
            }

            return monitorItem.links[linkName];
        },
        mergeMonitorItem: function (oldItem, newItem, overrideCurrents) {
            if (!oldItem.uptime || newItem.uptime > oldItem.uptime) {
                oldItem.uptime = newItem.uptime;
            }
            if (!oldItem.lastLogin || newItem.lastLogin < oldItem.lastLogin) {
                oldItem.lastLogin = newItem.lastLogin;
            }
            if (newItem.status) {
                oldItem.status = newItem.status;
            }
            if (newItem.socket) {
                oldItem.socket = newItem.socket;
            }
            if (newItem.devices) {
                oldItem.devices = newItem.devices;
            }
            if (newItem.protocol) {
                oldItem.protocol = newItem.protocol;
            }

            var type = newItem.site ? 'site' : (newItem.login ? 'login' : null);
            if (type && newItem[type]) {
                oldItem[type] = newItem[type];
            }

            if (overrideCurrents) {
                oldItem.distance = newItem.distance || newItem.distance || 0;
                oldItem.throughput = newItem.throughput;
                oldItem.packetLossUp = newItem.packetLossUp;
                oldItem.packetLossDown = newItem.packetLossDown;
            } else {
                oldItem.distance = Math.max(oldItem.distance || 0, newItem.distance || 0);
                if (!oldItem.throughput) {
                    oldItem.throughput = newItem.throughput;
                } else {
                    oldItem.throughput += newItem.throughput;
                }
                oldItem.packetLossUp = Math.max(oldItem.packetLossUp || 0, newItem.packetLossUp || 0);
                oldItem.packetLossDown = Math.max(oldItem.packetLossDown || 0, newItem.packetLossDown || 0);
            }
        },
        mergeItems: function (newItems, statsOnly, monitorItems) {
            var that = this;
            var linkKey;

            if (!statsOnly) {
                for (var key in monitorItems) {
                    if (newItems[key]) {
                        that.mergeMonitorItem(monitorItems[key], newItems[key]);

                        for (linkKey in monitorItems[key].links) {
                            if (newItems[key].links[linkKey]) {
                                newItems[key].links[linkKey].color = monitorItems[key].links[linkKey].color;
                                monitorItems[key].links[linkKey] = newItems[key].links[linkKey];
                            } else {
                                // that.removeCharts(key, linkKey);
                                monitorItems[key].links = {};
                            }
                        }
                    } else {
                        // that.removeCharts(key);
                        delete monitorItems[key];
                    }
                }
            }

            for (var newItemsKey in newItems) {
                var newItem = newItems[newItemsKey];
                monitorItems[newItemsKey] = newItem;

                if (newItem.site) {
                    var mergedLink = newItem.links.mergedLink || {
                        location: {},
                        serverPacketsSent: 0,
                        serverPacketsReceived: 0,
                        clientPacketsSent: 0,
                        clientPacketsReceived: 0,
                        rtStatsList: [],
                    };


                    newItem.links.mergedLink = null;
                    delete newItem.links.mergedLink;

                    for (linkKey in newItem.links) {
                        var currentLink = newItem.links[linkKey];
                        that.mergeLink(currentLink, mergedLink);
                    }

                    newItem.mergedLink = mergedLink;
                }
            }
        },
        mergeLink: function (currentLink, mergedLink) {
            var distanceSum = 0,
                count = 0,
                i = 0;

            if (currentLink.protocol) {
                mergedLink.protocol = currentLink.protocol;
            }


            distanceSum = 0;
            count = 0;
            for (i = 0; currentLink.rtStatsList[i]; i++) {
                if (!mergedLink.rtStatsList[i]) {
                    mergedLink.rtStatsList.push({
                        usage: currentLink.rtStatsList[i].usage || 0,
                        packetLossUp: currentLink.rtStatsList[i].packetLossUp || 0,
                        packetLossDown: currentLink.rtStatsList[i].packetLossDown || 0,
                        sampleTime: currentLink.rtStatsList[i].sampleTime,
                        sampleTimeEnd: currentLink.rtStatsList[i].sampleTimeEnd,
                        trafficDistributionReceived: currentLink.rtStatsList[i].trafficDistributionReceived || 0,
                        trafficDistributionSent: currentLink.rtStatsList[i].trafficDistributionSent || 0,
                    });
                } else {
                    mergedLink.rtStatsList[i].usage += (currentLink.rtStatsList[i].usage || 0);
                    mergedLink.rtStatsList[i].packetLossUp = Math.max(mergedLink.rtStatsList[i].packetLossUp, currentLink.rtStatsList[i].packetLossUp || 0);
                    mergedLink.rtStatsList[i].packetLossDown = Math.max(mergedLink.rtStatsList[i].packetLossDown, currentLink.rtStatsList[i].packetLossDown || 0);
                    mergedLink.rtStatsList[i].sampleTime = mergedLink.rtStatsList[i].sampleTime || currentLink.rtStatsList[i].sampleTime;
                    mergedLink.rtStatsList[i].sampleTimeEnd = mergedLink.rtStatsList[i].sampleTimeEnd || currentLink.rtStatsList[i].sampleTimeEnd;
                }


                if (currentLink.rtStatsList[i].distance) {
                    distanceSum += (currentLink.rtStatsList[i].distance || 0);
                    count++;
                }
            }

            for (i = 0; mergedLink.rtStatsList[i]; i++) {
                var currentStat = currentLink.rtStatsList[i] ? currentLink.rtStatsList[i] : {};
                mergedLink.rtStatsList[i].distance_Merged = Math.max(mergedLink.rtStatsList[i].distance_Merged || 0, currentStat.distance || 0);
                mergedLink.rtStatsList[i].throughputReceived_Merged = (mergedLink.rtStatsList[i].throughputReceived_Merged || 0) + (currentStat.throughputReceived || 0);
                mergedLink.rtStatsList[i].throughputSent_Merged = (mergedLink.rtStatsList[i].throughputSent_Merged || 0) + (currentStat.throughputSent || 0);
                mergedLink.rtStatsList[i].packetLossUp_Merged = Math.max(mergedLink.rtStatsList[i].packetLossUp_Merged || 0, (currentStat.packetLossUp || 0));
                mergedLink.rtStatsList[i].packetLossDown_Merged = Math.max(mergedLink.rtStatsList[i].packetLossDown_Merged || 0, (currentStat.packetLossDown || 0));
                mergedLink.rtStatsList[i].packetDiscardedUp_Merged = Math.max(mergedLink.rtStatsList[i].packetDiscardedUp_Merged || 0, (currentStat.packetDiscardedDownRaw || 0));
                mergedLink.rtStatsList[i].packetDiscardedDown_Merged = Math.max(mergedLink.rtStatsList[i].packetDiscardedDown_Merged || 0, (currentStat.packetDiscardedUpRaw || 0));
                mergedLink.rtStatsList[i].jitterUp_Merged = Math.max(mergedLink.rtStatsList[i].jitterUp_Merged || 0, (currentStat.jitterUp || 0));
                mergedLink.rtStatsList[i].jitterDown_Merged = Math.max(mergedLink.rtStatsList[i].jitterDown_Merged || 0, (currentStat.jitterDown || 0));
                mergedLink.rtStatsList[i].jitterOfoUp_Merged = Math.max(mergedLink.rtStatsList[i].jitterOfoUp_Merged || 0, (currentStat.jitterOfoUp || 0));
                mergedLink.rtStatsList[i].jitterOfoDown_Merged = Math.max(mergedLink.rtStatsList[i].jitterOfoDown_Merged || 0, (currentStat.jitterOfoDown || 0));
                if (!mergedLink.rtStatsList[i].pops_Merged) {
                    mergedLink.rtStatsList[i].pops_Merged = [];
                }
                mergedLink.rtStatsList[i].pops_Merged = _.uniq(mergedLink.rtStatsList[i].pops_Merged.concat(currentStat.pops || []));

                var currLinkName = currentLink.linkId;
                mergedLink.rtStatsList[i]['distance' + currLinkName] = currentStat.distance || 0;
                mergedLink.rtStatsList[i]['numOfHopsReceived' + currLinkName] = currentStat.numOfHopsReceived || 0;
                mergedLink.rtStatsList[i]['numOfHopsSent' + currLinkName] = currentStat.numOfHopsSent || 0;
                mergedLink.rtStatsList[i]['throughputReceived' + currLinkName] = currentStat.throughputReceived || 0;
                mergedLink.rtStatsList[i]['throughputSent' + currLinkName] = currentStat.throughputSent || 0;
                mergedLink.rtStatsList[i]['packetLossUp' + currLinkName] = currentStat.packetLossUp || 0;
                mergedLink.rtStatsList[i]['packetLossDown' + currLinkName] = currentStat.packetLossDown || 0;
                mergedLink.rtStatsList[i]['packetLossUpRaw' + currLinkName] = currentStat.packetLossUpRaw || 0;
                mergedLink.rtStatsList[i]['packetLossDownRaw' + currLinkName] = currentStat.packetLossDownRaw || 0;
                mergedLink.rtStatsList[i]['packetDiscardedUpRaw' + currLinkName] = currentStat.packetDiscardedUpRaw || 0;
                mergedLink.rtStatsList[i]['packetDiscardedDownRaw' + currLinkName] = currentStat.packetDiscardedDownRaw || 0;
                mergedLink.rtStatsList[i]['fecRecoveryRateUp' + currLinkName] = currentStat.fecRecoveryRateUp || 0;
                mergedLink.rtStatsList[i]['fecRecoveryRateDown' + currLinkName] = currentStat.fecRecoveryRateDown || 0;
                mergedLink.rtStatsList[i]['jitterUp' + currLinkName] = currentStat.jitterUp || 0;
                mergedLink.rtStatsList[i]['jitterDown' + currLinkName] = currentStat.jitterDown || 0;
                mergedLink.rtStatsList[i]['jitterOfoUp' + currLinkName] = currentStat.jitterOfoUp || 0;
                mergedLink.rtStatsList[i]['jitterOfoDown' + currLinkName] = currentStat.jitterOfoDown || 0;
                mergedLink.rtStatsList[i]['trafficDistributionReceived' + currLinkName] = currentStat.trafficDistributionReceived || 0;
                mergedLink.rtStatsList[i]['trafficDistributionSent' + currLinkName] = currentStat.trafficDistributionSent || 0;
                mergedLink.rtStatsList[i]['linkUtilizationSent' + currLinkName] = currentStat.linkUtilizationSent || 0;
                mergedLink.rtStatsList[i]['linkUtilizationReceived' + currLinkName] = currentStat.linkUtilizationReceived || 0;
                mergedLink.rtStatsList[i]['clientAugmentedBytes' + currLinkName] = currentStat.clientAugmentedBytes || 0;
                mergedLink.rtStatsList[i]['pops' + currLinkName] = currentStat.pops || '';
            }


            if (!mergedLink.distanceCounts) {
                mergedLink.distanceCounts = [];
            }
            mergedLink.distanceCounts.push({
                distanceSum: distanceSum || 0,
                count: count || 0,
            });

            var distanceCountTotal = 0,
                distanceSumTotal = 0,
                distanceCounter;
            for (distanceCounter in mergedLink.distanceCounts) {
                distanceCountTotal += mergedLink.distanceCounts[distanceCounter].count;
                distanceSumTotal += mergedLink.distanceCounts[distanceCounter].distanceSum;
            }
            mergedLink.distanceAverage = 0;
            for (distanceCounter in mergedLink.distanceCounts) {
                mergedLink.distanceAverage += (mergedLink.distanceCounts[distanceCounter].distanceSum /
                (mergedLink.distanceCounts[distanceCounter].count || 1)) * (mergedLink.distanceCounts[distanceCounter].count / distanceCountTotal);
            }

            mergedLink.distanceMax = Math.max(mergedLink.distanceMax || 0, currentLink.distanceMax || 0);
            mergedLink.maxBandwidthReceived = Math.max(mergedLink.maxBandwidthReceived || 0, currentLink.maxBandwidthReceived || 0);
            mergedLink.maxBandwidthSent = Math.max(mergedLink.maxBandwidthSent || 0, currentLink.maxBandwidthSent || 0);
            mergedLink.throughput = (mergedLink.throughput || 0) + (currentLink.throughput || 0);

            mergedLink.packetLossUp = Math.max(currentLink.packetLossUp || 0, mergedLink.packetLossUp || 0);
            mergedLink.packetLossDown = Math.max(currentLink.packetLossDown || 0, mergedLink.packetLossDown || 0);

            mergedLink.packetsReceivedDropped = currentLink.packetsReceivedDropped ? currentLink.packetsReceivedDropped : mergedLink.packetsReceivedDropped;
            mergedLink.packetsSentDropped = currentLink.packetsSentDropped ? currentLink.packetsSentDropped : mergedLink.packetsSentDropped;
            mergedLink.uptime = currentLink.uptime ? currentLink.uptime : mergedLink.uptime;
            mergedLink.lastLogin = currentLink.lastLogin ? currentLink.lastLogin : mergedLink.lastLogin;
            mergedLink.distance = Math.max(currentLink.distance || 0, mergedLink.distance || 0);
            mergedLink.internalIP = currentLink.internalIP ? currentLink.internalIP : mergedLink.internalIP;
            mergedLink.hostsCount = currentLink.hostsCount ? currentLink.hostsCount : mergedLink.hostsCount;
            mergedLink.status = currentLink.status === 'up' ? currentLink.status : mergedLink.status;
            mergedLink.distanceTotal = Math.max(mergedLink.distanceTotal || 0, currentLink.distanceTotal || 0);
            mergedLink.averageJitterUp = Math.max(mergedLink.averageJitterUp || 0, currentLink.averageJitterUp || 0);
            mergedLink.averageJitterDown = Math.max(mergedLink.averageJitterDown || 0, currentLink.averageJitterDown || 0);
            mergedLink.averageJitterOfoUp = Math.max(mergedLink.averageJitterOfoUp || 0, currentLink.averageJitterOfoUp || 0);
            mergedLink.averageJitterOfoDown = Math.max(mergedLink.averageJitterOfoDown || 0, currentLink.averageJitterOfoDown || 0);


            if (mergedLink.averageThroughputUp) {
                if (currentLink.averageThroughputUp) {
                    mergedLink.averageThroughputUp = ((mergedLink.averageThroughputUp * (mergedLink.serverPacketsReceived || 0)) +
                        (currentLink.averageThroughputUp * currentLink.serverPacketsReceived || 0)) / (mergedLink.serverPacketsReceived + currentLink.serverPacketsReceived) || 0;
                }
            } else {
                mergedLink.averageThroughputUp = currentLink.averageThroughputUp;
            }

            if (mergedLink.averageThroughputDown) {
                if (currentLink.averageThroughputDown) {
                    mergedLink.averageThroughputDown = ((mergedLink.averageThroughputDown * (mergedLink.clientPacketsReceived || 0)) +
                        (currentLink.averageThroughputDown * currentLink.clientPacketsReceived || 0)) / (mergedLink.clientPacketsReceived + currentLink.clientPacketsReceived) || 0;
                }
            } else {
                mergedLink.averageThroughputDown = currentLink.averageThroughputDown;
            }


            mergedLink.serverPacketsSent += currentLink.serverPacketsSent || 0;
            mergedLink.serverPacketsReceived += currentLink.serverPacketsReceived || 0;
            mergedLink.clientPacketsSent += currentLink.clientPacketsSent || 0;
            mergedLink.clientPacketsReceived += currentLink.clientPacketsReceived || 0;

            mergedLink.averagePacketLossUp = mergedLink.clientPacketsSent ? (1 - Math.min((mergedLink.serverPacketsReceived || 0) /
                mergedLink.clientPacketsSent, 1)) * 100 : 0;
            mergedLink.averagePacketLossDown = mergedLink.serverPacketsSent ? (1 - Math.min((mergedLink.clientPacketsReceived || 0) /
                mergedLink.serverPacketsSent, 1)) * 100 : 0;

            // currentLink.averagePacketLossUpRaw = currentLink.clientPacketsSent ? (1 - Math.min((currentLink.serverPacketsReceived || 0) / currentLink.clientPacketsSent, 1)) * 100 : 0;
            // currentLink.averagePacketLossDownRaw =  currentLink.serverPacketsSent ? (1 - Math.min((currentLink.clientPacketsReceived || 0) / currentLink.serverPacketsSent, 1)) * 100 : 0;

            if (!mergedLink.pops) {
                mergedLink.pops = [];
            }
        },
        processRTStats: function (item, fromDate, toDate) {
            var that = this;

            if (item.rtStatsList.length > 0) {
                item.rtStatsList.forEach(function (stats) {
                    stats.usage = stats.throughputReceived + stats.throughputSent;
                    stats.packetLossUp *= 100;
                    stats.packetLossDown *= 100;
                    stats.packetLossUpRaw *= 100;
                    stats.packetLossDownRaw *= 100;
                    stats.packetDiscardedUpRaw *= 100;
                    stats.packetDiscardedDownRaw *= 100;
                    stats.fecRecoveryRateUp *= 100;
                    stats.fecRecoveryRateDown *= 100;
                    stats.linkUtilizationSent *= 100;
                    stats.linkUtilizationReceived *= 100;
                    stats.trafficDistributionSent *= 100;
                    stats.trafficDistributionReceived *= 100;
                });
            } else {
                that.insertRangeStats(item.rtStatsList, fromDate, toDate);
            }
        },
        insertRangeStats: function (stats, fromDate, toDate) {
            stats.push({
                usage: 0,
                packetLossUp: 0,
                packetLossDown: 0,
                sampleCount: 0,
                health: [0],
                sampleTime: fromDate,
                sampleTimeEnd: fromDate + parseInt((toDate - fromDate) / 2),
            });
            stats.push({
                usage: 0,
                packetLossUp: 0,
                packetLossDown: 0,
                sampleCount: 0,
                health: [0],
                sampleTime: fromDate + parseInt((toDate - fromDate) / 2),
                sampleTimeEnd: toDate,
            });
        },
        /*addOfflineLinks: function (items) {
            if (items) {
                var itemsToAdd = [];
                items.forEach(function(monitorItem) {
                    if (monitorItem && monitorItem.site && !monitorItem.mergedLink) {
                        monitorItem.site.interfaceData.forEach(function(interfaceDataItem) {
                            var foundItem = false;
                            for (var i=0;items[i];i++) {
                                var monitorItemInner = items[i];
                                if (monitorItem.pid === monitorItemInner.pid && interfaceDataItem.interface_id === monitorItemInner.interfaceName && interfaceDataItem.interfaceType === monitorItemInner.interfaceType) {
                                    foundItem = true;
                                    break;
                                }
                            }

                            if (!foundItem) {
                                interfaceDataItem.rtStatsList = [];
                                interfaceDataItem.pid = monitorItem.pid;
                                interfaceDataItem.site = monitorItem.site;
                                interfaceDataItem.device = monitorItem.device;
                                interfaceDataItem.deviceId = monitorItem.deviceId;
                                interfaceDataItem.interfaceName = interfaceDataItem.interface_id;
                                itemsToAdd.push(interfaceDataItem);
                            }
                        });
                    }
                });
            }
            return items.concat(itemsToAdd);
        },*/
        processItems: function (items, fromDate, toDate, type, typesTitles) {
            var newMonitorItems = {};
            var that = this;

            //items = that.addOfflineLinks(items);
            items.forEach(function (item, index) {
                if (!type || item.interfaceType === type) {
                    if (item.uptime) {
                        item.oprigUptime = item.uptime;
                        item.uptime = moment.duration(item.uptime).humanize().replace('seconds', 's').replace('hours', 'h').replace('days', 'd').replace('minutes', 'm').replace('months', 'M');
                    }
                    that.processRTStats(item, fromDate, toDate);
                }


                if (newMonitorItems[item.pid]) {
                    if (newMonitorItems[item.pid].devices[item.deviceId]) {
                        if (item.status === 'up') {
                            newMonitorItems[item.pid].devices[item.deviceId].up = true;
                        }
                    } else {
                        newMonitorItems[item.pid].devices[item.deviceId] = {
                            id: item.deviceId,
                            up: item.status === 'up',
                        };
                    }

                    that.mergeMonitorItem(newMonitorItems[item.pid], item);
                } else {
                    if (item.lastLogin && item.lastLogin.toString().length > 13) {
                        item.lastLogin /= 1000;
                    }

                    newMonitorItems[item.pid] = {
                        links: {},
                        lastLogin: item.lastLogin,
                        status: item.status,
                        socket: item.socket,
                        pid: item.pid,
                        order: item.oprigUptime ? (item.oprigUptime*-100000000) : (item.lastLogin * -1),
                        uptime: item.uptime,
                        devices: {},
                        protocol: item.protocol,
                    };


                    newMonitorItems[item.pid].devices[item.deviceId] = {
                        id: item.deviceId,
                        up: item.status === 'up',
                    };

                    if (item.site) {
                        newMonitorItems[item.pid].site = item.site;
                    } else if (item.login) {
                        newMonitorItems[item.pid].login = item.login;
                    }
                }

                if (item.site && item.site.interfaceData) {
                    if (item.site.interfaceData.filter(function (interItem) { return interItem.interfaceType === 'ALTERNATIVE'; }).length > 0) {
                        if (!newMonitorItems[item.pid].alternativeLink) {
                        newMonitorItems[item.pid].alternativeLink = {};
                    }
                    }
                    if (item.site.interfaceData.filter(function (interItem) { return interItem.interfaceType === 'S2S_DEST'; }).length > 0) {
                       if (!newMonitorItems[item.pid].s2sLink) {
                        newMonitorItems[item.pid].s2sLink = {};
                    }
                    }

                }

                if (!type || item.interfaceType === type) {
                    var newLink = that.addLink(newMonitorItems[item.pid], item, type, typesTitles);

                    if (item.login) {
                        newMonitorItems[item.pid].mergedLink = newLink;
                    }

                    if (item.internalIP) {
                        newMonitorItems[item.pid].internalIP = item.internalIP;
                    }
                } else {
                    if (item.interfaceType === 'ALTERNATIVE') {
                        newMonitorItems[item.pid].alternativeLink = { online: true, throughput: item.throughput };
                    } else if (item.interfaceType === 'S2S_DEST') {
                        newMonitorItems[item.pid].s2sLink = { online: true, throughput: item.throughput };
                    }

                }
            });

            return newMonitorItems;
        },
        getData: function (options) {
            var that = this;
            var from = options.pagination ? (options.pagination.currentPage * options.pagination.pageSize) : 0;
            var limit = options.pagination ? options.pagination.pageSize : 1;
            if (options.fullUpdate) {
                /* if ($rootScope.showLoader) {
                 $timeout(function () {
                 $rootScope.showLoader(pageId);
                 }, 0);
                 }*/
            } else {
                from = 0;
                limit = options.DEFAULT_PAGE_SIZE || 1;
            }

            var queryConfig = {
                dateField: '',
                fromDate: 0,
                toDate: 0,
                from: from,
                limit: limit,
                searchField: 'name',
                searchFields: options.searchFields,
                search: options.searchVal,
                orders: [{ path: 'rt_status', dir: 'ASC' }, { path: 'db_name', dir: 'ASC' }],
                type: null,
                showOthers: false,
            };

            store.fetch({
                showLoader: options.loader,
                rt: options.statsOnly || !options.fullUpdate,
                // id: pageId,
                path: that.getUrl(options),
                filter: false,
                method: 'POST',
                data: queryConfig,
                dataObj: 'dataConfig',
                success: function (data) {
                    if (options.success) {
                        options.success(data);
                    }
                },
            });
        },
        getUrl: function (options) {
            var path;

            var fromDate;
            if (options.rt) {
                fromDate = '';
            } else {
                fromDate = options.from ? options.from.getTime() : options.globalMin;
                fromDate -= (fromDate % options.MIN_STATS_INTERVAL);
                options.scopeObject.fromDate = fromDate;
                var toDate = options.to ? options.to.getTime() : options.globalMax;
                if (toDate > new Date().getTime()) {
                    toDate = new Date();
                    toDate.setSeconds(0);
                    toDate.setMilliseconds(0);
                    toDate = toDate.getTime();
                }
                toDate -= (toDate % options.MIN_STATS_INTERVAL);

                options.scopeObject.toDate = toDate;
                var newInterval = 0;
                if (toDate && fromDate) {
                    newInterval = Math.floor((toDate - fromDate) / options.STATS_MIN_INTERVALS_COUNT);
                    newInterval = Math.floor(newInterval - (newInterval % options.MIN_STATS_INTERVAL));

                    if (newInterval < options.MIN_STATS_INTERVAL) {
                        while (newInterval < options.MIN_STATS_INTERVAL) {
                            fromDate -= options.MIN_STATS_INTERVAL;
                            toDate += options.MIN_STATS_INTERVAL;
                            newInterval = Math.floor((toDate - fromDate) / options.STATS_MIN_INTERVALS_COUNT);
                            newInterval = Math.floor(newInterval - (newInterval % options.MIN_STATS_INTERVAL));
                        }

                        options.scopeObject.from = new Date(fromDate);
                        options.scopeObject.to = new Date(toDate);
                    }

                    if (newInterval < (options.MIN_STATS_INTERVAL * options.STATS_MIN_INTERVALS_COUNT)) {
                        options.scopeObject.innerSegmentsCount = Math.floor(newInterval / options.MIN_STATS_INTERVAL);
                    } else {
                        options.scopeObject.innerSegmentsCount = options.STATS_MIN_INTERVALS_COUNT;
                    }
                    options.scopeObject.innerSegmentsCount = options.scopeObject.innerSegmentsCount - (Math.max(((toDate - fromDate)/ options.MIN_STATS_INTERVAL), 1) % options.scopeObject.innerSegmentsCount);
                }

                newInterval = Math.max(newInterval, options.MIN_STATS_INTERVAL);

                options.scopeObject.statsInterval = newInterval;
                options.scopeObject.interval = options.scopeObject.statsInterval;
                if (options.dateRange) {
                    options.dateRange.bucketDuration = newInterval;
                }
            }

            switch (options.scopeObject.type) {
                case 'sites':
                    path = '/getMonitor?type=sites&accountId=' + options.accountId;
                    if (options.scopeObject.pid || options.scopeObject.pid === 0) {
                        path += '&sites=' + options.scopeObject.pid;
                    } else if (!options.fullUpdate) {
                        path += '&sites=' + Object.keys(options.scopeObject.monitorItems);
                    }
                    break;
                case 'logins':
                    path = '/getMonitor?type=logins&accountId=' + options.accountId;
                    if (options.scopeObject.pid || options.scopeObject.pid === 0) {
                        path += '&logins=' + options.scopeObject.pid;
                    } else if (!options.fullUpdate) {
                        path += '&logins=' + Object.keys(options.scopeObject.monitorItems);
                    }
                    break;
            }

            var deviceAggregationType = options.deviceAggregationType ? options.deviceAggregationType : 'INTERFACE_NAME';
            path = path + '&rtStats=true&fromDate=' + fromDate + '&toDate=' + toDate + '&interval=' + newInterval + '&deviceAggregationType=' + deviceAggregationType +
                '&numberOfSegments=' + options.scopeObject.innerSegmentsCount + '&waitForAccount=true&getStats=' + (options.scopeObject.showrates ? 'rt' : 'dates' + '&mergeDevices=' + options.mergeDevices);
            return path;
        },
    };
});
